import { render, staticRenderFns } from "./SelecionarServidor.vue?vue&type=template&id=e39b7122&scoped=true&"
import script from "./SelecionarServidor.vue?vue&type=script&lang=js&"
export * from "./SelecionarServidor.vue?vue&type=script&lang=js&"
import style0 from "./SelecionarServidor.vue?vue&type=style&index=0&id=e39b7122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e39b7122",
  null
  
)

export default component.exports